import axios from 'axios'
import { config } from './config'

axios.defaults.baseURL = config('apiBaseUrl', process.env.API_BASE_URL)
axios.defaults.headers.common = {
  'Accept': 'application/json',
  'x-app-key': '2f9ca294-94b5-4382-a70d-c8770765d496'
}

axios.interceptors.response.use(
  response => {
    if (response.config.url.indexOf('api.ipgeolocation.io') !== -1) {
      return response.data
    }

    return response.data.data
  },
  error => {
    return Promise.reject(error.response.data)
  }
)

export default {
  specialities () {
    return axios.get('')
  },

  async addHospital (data) {
    try {
      await axios.post('/hospital/addHospital', data)
    } catch (error) {
      console.error('Error API-ADD_HOSPITAL')
    }
  },

  createHospital (hospital) {
    return axios.post('/hospital/addHospital', {
      name: hospital.name,
      address: hospital.address,
      email: hospital.email,
      type: hospital.type,
      contacts: `${hospital.countryCode}${hospital.contact}`,
      subdomain: hospital.subdomain
    })
  },

  addHospitalManager (hospitalId, manager) {
    return axios.post('/hospital/addDirectorHospital', {
      hospitalID: hospitalId,
      firstName: manager.firstname,
      lastName: manager.lastname,
      countryCode: manager.countryCode,
      phone: manager.phoneNumber,
      email: manager.email
    })
  },

  addHospitalAgent (hospitalId, manager) {
    return axios.post('/hospital/addSecretaryHospital', {
      hospitalID: hospitalId,
      firstName: manager.firstname,
      lastName: manager.lastname,
      countryCode: manager.countryCode,
      phone: manager.phoneNumber,
      email: manager.email
    })
  },

  addHospitalServices (hospitalId, services) {
    return axios.post('')
  },

  checkIfHospitalExists ({attr, value}) {
    return axios.get('/hospital/checkAttributeExists', {
      params: {
        key: attr,
        value: value
      }
    }).then(hospital => {
      return !!hospital
    }).catch(error => {
      console.log('error', error)
      return Promise.resolve()
    })
  },

  checkIfAccountExists ({type, phoneNumber}) {
    return axios.get('/accounts/accounts/isAccountExists', {
      params: {
        countryCode: '229',
        phone: phoneNumber,
        accountType: type
      }
    }).then(account => {
      return !!account
    }).catch(error => {
      console.log('error', error)
      return Promise.resolve()
    })
  },

  locateUser () {
    return axios.get('https://api.ipgeolocation.io/ipgeo?apiKey=e29f1d5ff99f4eb793ca0ba02df17f3e')
  }
}



// WEBPACK FOOTER //
// /src/api.js